import React from 'react';
import { Flex, Heading, Icon, Text } from 'roo-ui/components';
import PageBlock from 'components/PageBlock';

const ErrorBanner = () => (
  <PageBlock px={[4, 6, 0]} mt={15} data-print-style="page-block">
    <Flex p={[3, 6]} width={[1, 3 / 4, 2 / 3]} flexDirection="column" bg="ui.errorBackground">
      <Flex>
        <Icon name="warning" color="orange" mr={3} data-testid="banner-icon" />
        <Heading.h4 mb={0} data-testid="banner-title">
          Something went wrong.
        </Heading.h4>
      </Flex>
      <Text fontSize="base" data-testid="banner-message">
        Sorry, we were unable to send your enquiry this time. Please check the form and try again.
      </Text>
    </Flex>
  </PageBlock>
);

export default ErrorBanner;
